import React, { useRef, useEffect, useState } from "react";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";
// Reusable field components

function PaperlessDiscountField({
  value,
  onChange,
  name = "paperlessDiscount",
}: {
  value: string;
  onChange: (e: React.ChangeEvent<any>) => void;
  name?: string;
}) {
  return (
    <div className="form-group">
      <label>Paperless Discount</label>
      <select name={name} className="form-input compact-select" value={value} onChange={onChange}>
        <option value="">Select</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
      </select>
    </div>
  );
}

const TERM_OPTIONS = [
  { value: "Month", label: "Month" },
  { value: "Two Month", label: "2 Month" },
  { value: "Three Month", label: "3 Month" },
  { value: "Semi Annual", label: "Semi Annual" },
  { value: "Annual", label: "Annual" },
];
const bodilyInjuryLimitsDefault = ["10/20", "15/30", "25/50", "50/100", "100/300", "250/500", "500/500", "500/1000", "1000/1000", "None"];

const bodilyInjuryLimitsOhio = [
  "None",
  "25000/50000",
  "50000/100000",
  "100000/300000",
  "250000/500000",
  "300000/500000",
  "500000/500000",
  "500000/1000000",
  "1000000/1000000",
  "5000000/5000000",
  "75000 CSL",
  "100000 CSL",
  "200000 CSL",
  "300000 CSL",
  "500000 CSL",
  "1000000 CSL",
];

const bodilyInjuryLimitsAlabama = [
  "None",
  "25000/50000",
  "50000/100000",
  "100000/300000",
  "250000/500000",
  "300000/500000",
  "500000/500000",
  "500000/1000000",
  "1000000/1000000",
  "5000000/5000000",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];

const bodilyInjuryLimitsFlorida = [
  "None",
  "10000/20000",
  "15000/30000",
  "25000/50000",
  "50000/100000",
  "100000/300000",
  "250000/500000",
  "300000/500000",
  "500000/500000",
  "500000/1000000",
  "1000000/1000000",
  "5000000/5000000",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];

const bodilyInjuryLimitsGeorgia = [
  "None",
  "25000/50000",
  "50000/100000",
  "100000/300000",
  "250000/500000",
  "300000/500000",
  "500000/500000",
  "500000/1000000",
  "1000000/1000000",
  "5000000/5000000",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];

const bodilyInjuryLimitsTennessee = [
  "None",
  "25000/50000",
  "50000/100000",
  "100000/300000",
  "250000/500000",
  "300000/500000",
  "500000/500000",
  "500000/1000000",
  "1000000/1000000",
  "5000000/5000000",
  "65000 CSL",
  "100000 CSL",
  "200000 CSL",
  "300000 CSL",
  "500000 CSL",
  "1000000 CSL",
];

const bodilyInjuryLimitsSouthCarolina = [
  "None",
  "25000/50000",
  "50000/100000",
  "100000/300000",
  "250000/500000",
  "300000/300000",
  "300000/500000",
  "500000/500000",
  "500000/1000000",
  "1000000/1000000",
  "5000000/5000000",
  "75000 CSL",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];

const propertyDamageLimitsDefault = ["10", "25", "50", "100", "200", "250", "300", "400", "500", "750", "1000"];

const propertyDamageLimitsOhio = [
  "None",
  "25000",
  "50000",
  "100000",
  "250000",
  "300000",
  "500000",
  "1000000",
  "75000 CSL",
  "100000 CSL",
  "200000 CSL",
  "300000 CSL",
  "500000 CSL",
  "1000000 CSL",
];

const propertyDamageLimitsAlabama = [
  "None",
  "25000",
  "50000",
  "100000",
  "250000",
  "300000",
  "500000",
  "1000000",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];

const propertyDamageLimitsFlorida = [
  "None",
  "10000",
  "25000",
  "50000",
  "100000",
  "250000",
  "300000",
  "500000",
  "1000000",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];

const propertyDamageLimitsGeorgia = [
  "None",
  "25000",
  "50000",
  "100000",
  "250000",
  "300000",
  "500000",
  "1000000",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];

const propertyDamageLimitsTennessee = [
  "None",
  "25000",
  "50000",
  "100000",
  "250000",
  "300000",
  "500000",
  "1000000",
  "65000 CSL",
  "100000 CSL",
  "200000 CSL",
  "300000 CSL",
  "500000 CSL",
  "1000000 CSL",
];

const propertyDamageLimitsSouthCarolina = [
  "None",
  "25000",
  "50000",
  "100000",
  "250000",
  "300000",
  "500000",
  "1000000",
  "75000 CSL",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];

const pipTypeBase = ["Basic", "Extended"];
const pipTypeFlorida = ["Basic", "Extended"];

const pipDedBase = ["0", "250", "500", "1000"];
const pipDedFlorida = ["0", "250", "500", "1000"];

const pipDedOptionBase = ["NI", "NTRR"];
const pipDedOptionFlorida = ["Named Insured", "Named Insured/Resident Relatives"];

const wageLossExclusionBase = ["Yes", "No"];
const uninsuredTypeOptions = ["None", "Reduced", "AddedOn"];

const uninsuredPdLimitsOhio = [
  "None",
  "7000",
  "10000",
  "15000",
  "25000",
  "50000",
  "100000",
  "75000 CSL",
  "100000 CSL",
  "200000 CSL",
  "300000 CSL",
  "500000 CSL",
  "1000000 CSL",
];
const uninsuredPdLimitsGeorgia = ["None", "25000", "50000", "100000", "100000 CSL", "300000 CSL", "500000 CSL"];
const uninsuredPdLimitsTennessee = [
  "None",
  "15000",
  "20000",
  "25000",
  "35000",
  "50000",
  "100000",
  "250000",
  "60000 CSL",
  "65000 CSL",
  "100000 CSL",
  "200000 CSL",
  "300000 CSL",
  "500000 CSL",
  "1000000 CSL",
];
const uninsuredPdLimitsSouthCarolina = ["None", "25000", "50000", "100000", "75000 CSL", "100000 CSL", "300000 CSL", "500000 CSL"];
const uninsuredPdLimitsDefault = ["25", "50", "100", "None"];

const underinsuredPdOptions = ["25", "50", "100", "None"];
const underinsuredPdLimitsSouthCarolina = ["None", "25000", "50000", "100000", "75000 CSL", "100000 CSL", "300000 CSL", "500000 CSL"];

const UNINSURED_PD_DED = ["250", "500", "1000", "None"];
const UNINSURED_PD_DED_GEORGIA = ["None", "250", "500", "1000"];

const umStackedMedicalPaymentOptions = ["Yes", "No"];

const medicalPaymentLimitsDefault = ["500", "1000", "2000", "2500", "5000", "10000", "25000", "50000", "None"];
const medicalPaymentLimitsFlorida = ["None", "500", "1000", "2000", "5000"];
const medicalPaymentLimitsGeorgia = ["None", "500", "1000", "2000", "5000", "10000"];
const medicalPaymentLimitsOhio = ["None", "500", "1000", "2000", "5000", "10000", "25000", "50000"];
const medicalPaymentLimitsSouthCarolina = ["None", "500", "1000", "2000", "5000", "10000"];
const medicalPaymentLimitsTennessee = ["None", "250", "500", "750", "1000", "2000", "2500", "5000", "10000"];
const medicalPaymentLimitsAlabama = ["None", "500", "1000", "2000", "5000", "10000", "25000"];

const accidentalDeathLimitsOhio = ["None", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000", "9000", "10000"];
const accidentalDeathLimitsAlabama = ["None", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000", "9000", "10000"];
const accidentalDeathLimitsGeorgia = ["None", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000", "9000", "10000"];
const accidentalDeathLimitsTennessee = ["None", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000", "9000", "10000"];
const accidentalDeathLimitsSouthCarolina = ["None", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000", "9000", "10000"];
const accidentalDeathLimitsFlorida = ["None", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000", "9000", "10000"];
const accidentalDeathLimitsDefault = ["1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000", "9000", "10000", "None"];

const umbiLimitsOhio = [
  "None",
  "12000/25000",
  "15000/30000",
  "25000/50000",
  "50000/100000",
  "100000/300000",
  "250000/500000",
  "300000/500000",
  "500000/500000",
  "500000/1000000",
  "1000000/1000000",
  "75000 CSL",
  "100000 CSL",
  "200000 CSL",
  "300000 CSL",
  "500000 CSL",
  "1000000 CSL",
];
const umbiLimitsAlabama = [
  "None",
  "25000/50000",
  "50000/100000",
  "100000/300000",
  "250000/500000",
  "300000/500000",
  "500000/500000",
  "500000/1000000",
  "1000000/1000000",
  "5000000/5000000",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];
const umbiLimitsFlorida = [
  "None",
  "10000/20000",
  "15000/30000",
  "25000/50000",
  "50000/100000",
  "100000/300000",
  "250000/500000",
  "300000/500000",
  "500000/500000",
  "500000/1000000",
  "1000000/1000000",
  "5000000/5000000",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];
const umbiLimitsGeorgia = [
  "None",
  "25000/50000",
  "50000/100000",
  "100000/300000",
  "250000/500000",
  "500000/500000",
  "500000/1000000",
  "1000000/1000000",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];
const umbiLimitsTennessee = [
  "None",
  "25000/50000",
  "50000/100000",
  "100000/300000",
  "250000/500000",
  "300000/500000",
  "500000/500000",
  "500000/1000000",
  "1000000/1000000",
  "60000 CSL",
  "65000 CSL",
  "100000 CSL",
  "200000 CSL",
  "300000 CSL",
  "500000 CSL",
  "1000000 CSL",
];
const umbiLimitsDefault = [
  "25/50",
  "50/100",
  "100/300",
  "250/500",
  "300/300",
  "300/500",
  "500/500",
  "500/1 mil",
  "1 mil/1 mil",
  "75 CSL",
  "100 CSL",
  "300 CSL",
  "500 CSL",
  "None",
];
const umbiLimitsSouthCarolina = [
  "None",
  "25000/50000",
  "50000/100000",
  "100000/300000",
  "250000/500000",
  "300000/300000",
  "300000/500000",
  "500000/500000",
  "500000/1000000",
  "1000000/1000000",
  "5000000/5000000",
  "75000 CSL",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];

const uimbiLimitsOhio = [
  "None",
  "12000/25000",
  "15000/30000",
  "25000/50000",
  "50000/100000",
  "100000/300000",
  "250000/500000",
  "300000/500000",
  "500000/500000",
  "500000/1000000",
  "1000000/1000000",
  "75000 CSL",
  "100000 CSL",
  "200000 CSL",
  "300000 CSL",
  "500000 CSL",
  "1000000 CSL",
];

const uimbiLimitsSouthCarolina = [
  "None",
  "25000/50000",
  "50000/100000",
  "100000/300000",
  "250000/500000",
  "300000/300000",
  "300000/500000",
  "500000/500000",
  "500000/1000000",
  "1000000/1000000",
  "5000000/5000000",
  "75000 CSL",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];

const uimbiLimitsDefault = [
  "25/50",
  "50/100",
  "100/300",
  "250/500",
  "300/300",
  "300/500",
  "500/500",
  "500/1 mil",
  "1mil/1 mil",
  "75 CSL",
  "100 CSL",
  "300 CSL",
  "500 CSL",
   "None",
];

const initialPolicyData = {
  term: "",
  bodilyInjury: "",
  propertyDamage: "",
  pipType: "",
  pipDed: "",
  pipDedOption: "",
  wageLossExclusion: "",
  uninsuredType: "",
  uninsuredBI: "",
  underinsuredBI: "",
  uninsuredPD: "",
  underinsuredPD: "",
  uninsuredPDDed: "",
  umStacked: "",
  medicalPayments: "",
  accidentalDeath: "",
  paperlessDiscount: "",
};
export default function PolicyInformationConfig({
  policyInformationConfigurationList,
  state,
  getPolicyInformationConfigurationDetails,
  loading,
}: {
  policyInformationConfigurationList: any;
  state: string;
  getPolicyInformationConfigurationDetails: () => void;
  loading: boolean;
}) {
  const formRef = useRef<HTMLFormElement>(null);
  const toast = React.useRef<Toast>(null);
  const navigate = useNavigate();
  const [saveLoading, setSaveLoading] = useState(false);
  const [formData, setFormData] = useState(initialPolicyData);

  useEffect(() => {    
    if (policyInformationConfigurationList) {
      setFormData({
        term: policyInformationConfigurationList.term ?? "",
        bodilyInjury: policyInformationConfigurationList.bodilyInjury ?? "",
        propertyDamage: policyInformationConfigurationList.propertyDamage ?? "",
        pipType: policyInformationConfigurationList.pipType ?? "",
        pipDed: policyInformationConfigurationList.pipDed ?? "",
        pipDedOption: policyInformationConfigurationList.pipDedOption ?? "",
        wageLossExclusion: policyInformationConfigurationList.wageLossExclusion ?? "",
        uninsuredType: policyInformationConfigurationList.uninsuredType ?? "",
        uninsuredBI: policyInformationConfigurationList.uninsuredBI ?? "",
        underinsuredBI: policyInformationConfigurationList.underinsuredBI ?? "",
        uninsuredPD: policyInformationConfigurationList.uninsuredPD ?? "",
        underinsuredPD: policyInformationConfigurationList.underinsuredPD ?? "",
        uninsuredPDDed: policyInformationConfigurationList.uninsuredPDDed ?? "",
        umStacked: policyInformationConfigurationList.uM_Stacked ?? "",
        medicalPayments: policyInformationConfigurationList.medicalPayments ?? "",
        accidentalDeath: policyInformationConfigurationList.accidentalDeath ?? "",
        paperlessDiscount: policyInformationConfigurationList.paperlessDiscount ?? "",
      });
    }
  }, [policyInformationConfigurationList]);
 
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const onPolicyInformationConfigurationSaveClick = () => {
    if (!state || state.trim() === "") {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: "State is required.",
        life: 3000,
      });
      return;
    }

    setSaveLoading(true);
    let data = JSON.stringify({
      term: formData.term,
      bodilyInjury: formData.bodilyInjury,
      propertyDamage: formData.propertyDamage,
      pipType: formData.pipType,
      pipDed: formData.pipDed,
      pipDedOption: formData.pipDedOption,
      wageLossExclusion: formData.wageLossExclusion,
      uninsuredType: formData.uninsuredType,
      uninsuredBI: formData.uninsuredBI ?? "",
      underinsuredBI: formData.underinsuredBI,
      uninsuredPD: formData.uninsuredPD,
      underinsuredPD: formData.underinsuredPD,
      uninsuredPDDed: formData.uninsuredPDDed,
      uM_Stacked: formData.umStacked,
      medicalPayments: formData.medicalPayments,
      accidentalDeath: formData.accidentalDeath,
      paperlessDiscount: formData.paperlessDiscount,
      state: state,
    });

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_ACE_API_Url}/api/ace/policyinformationconfiguration`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then((response: any) => {
        setSaveLoading(false);
        getPolicyInformationConfigurationDetails();
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Policy information configurations saved successfully!",
          life: 3000,
        });
      })
      .catch((error: any) => {
        setSaveLoading(false);
        if (error.response && error.response.status === 401) {
          localStorage.clear();
          navigate("/");
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail:
              error.response && error.response.status
                ? `Error ${error.response.status}: ${error.response.data?.message || "An error occurred while saving the policy information configurations!"}`
                : "Unknown error while saving the policy information configurations!",
            life: 3000,
          });
        }
      });
  };
  return (
    <div>
      <div className="config-info-banner">
        <div className="config-info-icon">
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
            <line x1="12" y1="8" x2="12" y2="8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M12 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>
        <div className="config-info-text">
          <p className="feature-bold">Policy Information Settings</p>
          <span className="feature-label">Configure policy defaults and behavior below.</span>
        </div>
      </div>
      <div style={{ position: "relative" }}>
        {loading && (
          <div className="driver-loading-overlay">
            <div className="driver-loading-content">
              <div className="driver-loading-spinner" />
              <p className="driver-loading-text">Loading policy configuration...</p>
            </div>
          </div>
        )}
        <form ref={formRef}>
          <div
            className="form-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, minmax(220px, 1fr))",
              gap: "1rem",
            }}
          >
            {" "}
            {/* Term */}
            <div className="form-group">
              <label htmlFor="term">Term</label>
              <select id="term" className="form-input" name="term" value={formData.term} onChange={handleChange}>
                <option value="" >
                  Select term
                </option>
                {TERM_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            <PaperlessDiscountField value={formData.paperlessDiscount} onChange={handleChange} />
            {/* Bodily Injury */}
            <div className="form-group">
              <label htmlFor="bodily-injury">Bodily Injury</label>
              <select id="bodily-injury" name="bodilyInjury" className="form-input" value={formData.bodilyInjury} onChange={handleChange}>
                <option value="" >
                  Select BI
                </option>
                {(state === "Ohio"
                  ? bodilyInjuryLimitsOhio
                  : state === "Alabama"
                    ? bodilyInjuryLimitsAlabama
                    : state === "Florida"
                      ? bodilyInjuryLimitsFlorida
                      : state === "Georgia"
                        ? bodilyInjuryLimitsGeorgia
                        : state === "Tennessee"
                          ? bodilyInjuryLimitsTennessee
                          : state === "South Carolina"
                            ? bodilyInjuryLimitsSouthCarolina
                            : bodilyInjuryLimitsDefault
                ).map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            {/* Property Damage */}
            <div className="form-group">
              <label htmlFor="property-damage">Property Damage</label>
              <select id="property-damage" name="propertyDamage" className="form-input" value={formData.propertyDamage} onChange={handleChange}>
                <option value="" >
                  Select PD
                </option>
                {(state === "Ohio"
                  ? propertyDamageLimitsOhio
                  : state === "Alabama"
                    ? propertyDamageLimitsAlabama
                    : state === "Florida"
                      ? propertyDamageLimitsFlorida
                      : state === "Georgia"
                        ? propertyDamageLimitsGeorgia
                        : state === "Tennessee"
                          ? propertyDamageLimitsTennessee
                          : state === "South Carolina"
                            ? propertyDamageLimitsSouthCarolina
                            : propertyDamageLimitsDefault
                ).map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            {/* PIP Type */}
            <div className="form-group">
              <label htmlFor="pip-type">PIP Type</label>
              <select id="pip-type" className="form-input" name="pipType" value={formData.pipType} onChange={handleChange}>
                <option value="" >
                  Select type
                </option>
                {(state === "Florida"
                  ? pipTypeFlorida
                  : ["Alabama", "Georgia", "Ohio", "South Carolina", "Tennessee"].includes(state)
                    ? [...pipTypeBase, "None"]
                    : pipTypeBase
                ).map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            {/* PIP Ded */}
            <div className="form-group">
              <label htmlFor="pip-ded">PIP Ded</label>
              <select id="pip-ded" className="form-input" name="pipDed" value={formData.pipDed} onChange={handleChange}>
                <option value="" >
                  Select ded
                </option>
                {(state === "Florida"
                  ? pipDedFlorida
                  : ["Alabama", "Georgia", "Ohio", "South Carolina", "Tennessee"].includes(state)
                    ? [...pipDedBase, "None"]
                    : pipDedBase
                ).map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            {/* PIP Ded Option */}
            <div className="form-group">
              <label htmlFor="pip-ded-option">PIP Ded Option</label>
              <select
                id="pip-ded-option"
                className="form-input compact-select"
                name="pipDedOption"
                value={formData.pipDedOption}
                onChange={handleChange}
              >
                <option value="" >
                  Select option
                </option>
                {(state === "Florida"
                  ? pipDedOptionFlorida
                  : ["Alabama", "Georgia", "Ohio", "South Carolina", "Tennessee"].includes(state)
                    ? [...pipDedOptionBase, "None"]
                    : pipDedOptionBase
                ).map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            {/* Wage Loss Exclusion */}
            <div className="form-group">
              <label htmlFor="wage-loss">Wage Loss Exclusion</label>
              <select
                id="wage-loss"
                className="form-input compact-select"
                name="wageLossExclusion"
                value={formData.wageLossExclusion}
                onChange={handleChange}
              >
                <option value="" >
                  Select
                </option>
                {(["Alabama", "Georgia", "Ohio", "South Carolina", "Tennessee"].includes(state)
                  ? [...wageLossExclusionBase, "None"]
                  : wageLossExclusionBase
                ).map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            {/* Uninsured Type (GA only) */}
            {state === "Georgia" && (
              <div className="form-group">
                <label htmlFor="uninsured-type">Uninsured Type</label>
                <select
                  id="uninsured-type"
                  className="form-input compact-select"
                  name="uninsuredType"
                  value={formData.uninsuredType}
                  onChange={handleChange}
                >
                  <option value="" >
                    Select Type
                  </option>
                  {uninsuredTypeOptions.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {/* Uninsured BI (UMBI) */}
            <div className="form-group">
              <label htmlFor="umbi">Uninsured BI (UMBI)</label>
              <select id="umbi" className="form-input compact-select" name="uninsuredBI" value={formData.uninsuredBI} onChange={handleChange}>
                <option value="" >
                  Select UMBI
                </option>
                {(state === "Ohio"
                  ? umbiLimitsOhio
                  : state === "Alabama"
                    ? umbiLimitsAlabama
                    : state === "Florida"
                      ? umbiLimitsFlorida
                      : state === "Georgia"
                        ? umbiLimitsGeorgia
                        : state === "Tennessee"
                          ? umbiLimitsTennessee
                          : state === "South Carolina"
                            ? umbiLimitsSouthCarolina
                            : umbiLimitsDefault
                ).map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            {/* Uninsured PD */}
            <div className="form-group">
              <label htmlFor="uninsured-pd">Uninsured PD</label>
              <select id="uninsured-pd" className="form-input compact-select" name="uninsuredPD" value={formData.uninsuredPD} onChange={handleChange}>
                <option value="" >
                  Select PD
                </option>
                {(state === "Ohio"
                  ? uninsuredPdLimitsOhio
                  : state === "Georgia"
                    ? uninsuredPdLimitsGeorgia
                    : state === "Tennessee"
                      ? uninsuredPdLimitsTennessee
                      : state === "South Carolina"
                        ? uninsuredPdLimitsSouthCarolina
                        : uninsuredPdLimitsDefault
                ).map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            {/* Uninsured PD Ded (GA only) */}
            {state === "Georgia" && (
              <div className="form-group">
                <label htmlFor="uninsured-pd-ded">Uninsured PD Ded</label>
                <select
                  id="uninsured-pd-ded"
                  className="form-input compact-select"
                  name="uninsuredPDDed"
                  value={formData.uninsuredPDDed}
                  onChange={handleChange}
                >
                  <option value="" >
                    Select Deductible
                  </option>
                  {UNINSURED_PD_DED_GEORGIA.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {/* Underinsured BI (UIMBI) */}
            <div className="form-group">
              <label htmlFor="uimbi">Underinsured BI (UIMBI)</label>
              <select id="uimbi" className="form-input compact-select" name="underinsuredBI" value={formData.underinsuredBI} onChange={handleChange}>
                <option value="" >
                  Select UIMBI
                </option>
                {(state === "Ohio" ? uimbiLimitsOhio : state === "South Carolina" ? uimbiLimitsSouthCarolina : uimbiLimitsDefault).map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            {/* Underinsured PD (SC only) */}
            {state === "South Carolina" && (
              <div className="form-group">
                <label htmlFor="underinsured-pd">Underinsured PD</label>
                <select
                  id="underinsured-pd"
                  className="form-input compact-select"
                  name="underinsuredPD"
                  value={formData.underinsuredPD}
                  onChange={handleChange}
                >
                  <option value="" >
                    Select PD
                  </option>
                  {underinsuredPdLimitsSouthCarolina.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {/* UM Stacked */}
            <div className="form-group">
              <label htmlFor="um-stacked">UM Stacked</label>
              <select id="um-stacked" className="form-input compact-select" name="umStacked" value={formData.umStacked} onChange={handleChange}>
                <option value="" >
                  Select
                </option>
                {umStackedMedicalPaymentOptions.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            {/* Medical Payments */}
            <div className="form-group">
              <label htmlFor="medical-payments">Medical Payments</label>
              <select
                id="medical-payments"
                className="form-input compact-select"
                name="medicalPayments"
                value={formData.medicalPayments}
                onChange={handleChange}
              >
                <option value="" >
                  Select amount
                </option>
                {(state === "Ohio"
                  ? medicalPaymentLimitsOhio
                  : state === "Alabama"
                    ? medicalPaymentLimitsAlabama
                    : state === "Florida"
                      ? medicalPaymentLimitsFlorida
                      : state === "Georgia"
                        ? medicalPaymentLimitsGeorgia
                        : state === "Tennessee"
                          ? medicalPaymentLimitsTennessee
                          : state === "South Carolina"
                            ? medicalPaymentLimitsSouthCarolina
                            : medicalPaymentLimitsDefault
                ).map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            {/* Accidental Death */}
            <div className="form-group">
              <label htmlFor="accidental-death">Accidental Death</label>
              <select
                id="accidental-death"
                className="form-input compact-select"
                name="accidentalDeath"
                value={formData.accidentalDeath}
                onChange={handleChange}
              >
                <option value="" >
                  Select amount
                </option>
                {(state === "Ohio"
                  ? accidentalDeathLimitsOhio
                  : state === "Alabama"
                    ? accidentalDeathLimitsAlabama
                    : state === "Georgia"
                      ? accidentalDeathLimitsGeorgia
                      : state === "Tennessee"
                        ? accidentalDeathLimitsTennessee
                        : state === "South Carolina"
                          ? accidentalDeathLimitsSouthCarolina
                          : state === "Florida"
                            ? accidentalDeathLimitsFlorida
                            : accidentalDeathLimitsDefault
                ).map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="tab-actions">
            <button type="button" className="btn btn-primary" onClick={onPolicyInformationConfigurationSaveClick} disabled={saveLoading}>
              {saveLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
